import {
    IStationApi,
    IStationDetailsRequest
} from '../../api/station-api.service';
import {IStationDetails} from '../details/edit.controller';
import {StateService} from 'angular-ui-router';
import {IImomoErrorService} from '../../error/error.service';

export default class StationCreatorController {
  static $inject = ['$state', 'stationApi', 'imomoErrorService'];

  selectedTabIndex:number;
  stationDetails:IStationDetails;
  historicalDataFile:File;
  isLoading:boolean;

  private isStepOneValid:boolean;
  private isStepTwoValid:boolean;
  private isStepThreeValid:boolean;

  constructor(
    private $state:StateService,
    private stationApi:IStationApi,
    private imomoErrorService: IImomoErrorService) {}

  $onInit() {
    this.isStepOneValid = false;
    this.isStepTwoValid = true;
  }

  get isStepTwoDisabled() {
    return !this.isStepOneValid;
  }

  get isNextButtonDisabled() {
    switch (this.selectedTabIndex) {
      case 0:
        return this.isStepTwoDisabled;
      default:
        return true;
    }
  }

  get isPrevButtonDisabled() {
    switch (this.selectedTabIndex) {
      case 0:
        return true;
      default:
        return false;
    }
  }

  get isSubmitButtonDisabled() {
    return !this.isStepOneValid
        || !this.isStepTwoValid
        || this.isLoading;
  }

  get isLastStep() {
    return this.selectedTabIndex == 1;
  }

  onStationDetailsChange(station:IStationDetails, isValid:boolean) {
    this.isStepOneValid = isValid;
    this.stationDetails = station;
  }

  onHistoricalDataChange(dataFile:File, isValid:boolean) {
    this.isStepTwoValid = isValid;
    this.historicalDataFile = dataFile;
  }

  nextStep() {
    this.selectedTabIndex += 1;
  }

  prevStep() {
    this.selectedTabIndex -= 1;
  }

  createStation() {
    this.isLoading = true;
    const stationRequest:IStationDetailsRequest = {
      siteName: this.stationDetails.name,
      siteCode: this.stationDetails.code,
      country: this.stationDetails.country,
      basin: this.stationDetails.basin,
      region: this.stationDetails.region,
      latitude: this.stationDetails.location.latitude,
      longitude: this.stationDetails.location.longitude
    };
    this.stationApi.createMeteoStation(stationRequest,
        this.historicalDataFile)
        .then(() => {
          this.$state.go('meteostation.manager');
        })
        .catch((error:any) => {
          this.imomoErrorService.showErrorDetailsDialog(error.data.details);
        })
        .finally(() => {
          this.isLoading = false;
        });
  }
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/creator/creator.controller.ts
 **/